import { z } from 'zod';

/**
 * Tipos primitivos do dominio, definidos uma vez e reaproveitados nos schemas
 * de rota. Sao eles que impedem, por exemplo, que uma competencia chegue como
 * "2026-1" num lado e "2026-01" no outro.
 */

/** Competencia contabil no formato `YYYY-MM`. Ex.: `2026-01`. */
export const monthKey = z
  .string()
  .regex(/^\d{4}-(0[1-9]|1[0-2])$/, 'Competencia deve estar no formato AAAA-MM.');

/** Data civil no formato `YYYY-MM-DD`. */
export const isoDate = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Data deve estar no formato AAAA-MM-DD.');

/**
 * O mesmo limite aplicado no login do sistema legado: 128 caracteres e um
 * padrao deliberadamente simples. Validacao de e-mail por regex elaborada gera
 * mais falso negativo que protecao — quem confirma o endereco e o envio.
 */
export const email = z
  .string()
  .trim()
  .toLowerCase()
  .max(128, 'E-mail muito longo.')
  .regex(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, 'E-mail invalido.');

/**
 * Limites de senha. O minimo de 8 acompanha o OWASP; o maximo de 200 existe
 * para que ninguem transforme o endpoint de login em DoS mandando megabytes
 * para o Argon2id derivar.
 */
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 200;

export const password = z
  .string()
  .min(PASSWORD_MIN_LENGTH, `Senha deve ter ao menos ${PASSWORD_MIN_LENGTH} caracteres.`)
  .max(PASSWORD_MAX_LENGTH, `Senha deve ter no maximo ${PASSWORD_MAX_LENGTH} caracteres.`);

/** Identificador numerico vindo da URL, que chega sempre como string. */
export const idParam = z.coerce.number().int().positive();

/** Papel do usuario. `admin` destrava periodo fechado e gerencia contas. */
export const role = z.enum(['admin', 'user']);
export type Role = z.infer<typeof role>;

/**
 * Origem fiscal do lancamento. Separa o que compoe o DRE oficial do que e
 * movimentacao apenas gerencial.
 *
 * `Nao Fiscal` vai sem cedilha de proposito: e exatamente o literal ja gravado
 * na coluna `transactions.fiscal_type` em producao. Acentuar aqui faria os
 * lancamentos existentes deixarem de casar com o filtro.
 */
export const fiscalType = z.enum(['Fiscal', 'Nao Fiscal']);
export type FiscalType = z.infer<typeof fiscalType>;
